import React, { useEffect, useState } from 'react';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';

import { Axios } from 'helpers/axios';
import { AxiosUpload } from 'helpers/axiosFileUpload';
import IconButton from 'components/common/IconButton';

const DemandeDPSStep6 = ({
    watch1,
    watch2,
    watch3,
    watch4,
    resetForm,
    demandeUpdateCode,
}) => {
    const [isLoading, setIsLoading] = useState(true);

    const sendToDB = async () => {
        try {
            setIsLoading(true);
            const sendToBO = await Axios.post('/publicRoutes/enregistrerDemandeDPS',{
                demandeUpdateCode            : demandeUpdateCode || null,
                idStructureClient            : watch1("idStructureClient") ? watch1("idStructureClient").idStructureClient : null,
                orgaRaisonSociale            : watch1("orgaRaisonSociale"),
                orgaAdresse                  : watch1("orgaAdresse"),
                orgaRepresentantLegal        : watch1("orgaRepresentantLegal"),
                orgaRepresentantLegalFonction: watch1("orgaRepresentantLegalFonction"),
                orgaRepresentantLegalMail    : watch1("orgaRepresentantLegalMail"),
                orgaRepresentantLegalTel     : watch1("orgaRepresentantLegalTel"),
                orgaRepresentePar            : watch1("orgaRepresentePar"),
                orgaRepresenteParFonction    : watch1("orgaRepresenteParFonction"),
                orgaRepresenteParMail        : watch1("orgaRepresenteParMail"),
                orgaRepresenteParTel         : watch1("orgaRepresenteParTel"),
                orgaFacturationMail          : watch1("orgaFacturationMail"),
                orgaFacturationTel           : watch1("orgaFacturationTel"),
                orgaContactLocal             : watch1("orgaContactLocal"),
                orgaContactLocalFonction     : watch1("orgaContactLocalFonction"),
                orgaContactLocalTel          : watch1("orgaContactLocalTel"),

                libelleEvenement             : watch2("libelleEvenement"),
                activiteEvenement            : watch2("activiteEvenement"),
                dateDebutEvenement           : watch2("dateDebutEvenement"),
                manifNomLieu                 : watch2("manifNomLieu"),
                manifAdresse                 : watch2("manifAdresse"),
                manifCP                      : watch2("manifCP"),
                manifVille                   : watch2("manifVille"),
                manifInternational           : watch2("manifInternational"),
                manifSurVP                   : watch2("manifSurVP"),
                manifSurVPFermee             : watch2("manifSurVPFermee"),
                manifCircuit                 : watch2("manifCircuit"),
                manifCircuitCarrossable      : watch2("manifCircuitCarrossable"),
                manifE1Accessibilite         : watch2("manifE1Accessibilite"),
                manifRisqueSite              : watch2("manifRisqueSite"),
                manifE2DelaisSP              : watch2("manifE2DelaisSP"),
                manifSPproches               : watch2("manifSPproches"),
                manifCHUproches              : watch2("manifCHUproches"),
                manifRemarques               : watch2("manifRemarques"),
                accueilAutreAASC             : watch2("accueilAutreAASC"),
                accueilAutreAASCDetails      : watch2("accueilAutreAASCDetails"),
                accueilSME                   : watch2("accueilSME"),
                accueilSMEDetails            : watch2("accueilSMEDetails"),
                accueilMedicalAutreSME       : watch2("accueilMedicalAutreSME"),
                accueilAP                    : watch2("accueilAP"),
                accueilSAMU                  : watch2("accueilSAMU"),
                accueilSP                    : watch2("accueilSP"),
                accueilSecuPrivee            : watch2("accueilSecuPrivee"),
                accueilFDO                   : watch2("accueilFDO"),
                accueilRadioOrga             : watch2("accueilRadioOrga"),
                accueilLocauxIS              : watch2("accueilLocauxIS"),
                accueilTenteIS               : watch2("accueilTenteIS"),
                accueilMobilierIS            : watch2("accueilMobilierIS"),
                accueilElectricite           : watch2("accueilElectricite"),
                accueilEau                   : watch2("accueilEau"),
                accueilChauffage             : watch2("accueilChauffage"),
                accueilLumiere               : watch2("accueilLumiere"),
                accueilRepas                 : watch2("accueilRepas"),
                accueilEauCanicule           : watch2("accueilEauCanicule"),
                accueilReposIS               : watch2("accueilReposIS"),

                parties                      : watch3("parties"),
            });

            if(watch4("files") && Array.isArray(watch4("files")))
            {
                for(const file of watch4("files"))
                {
                    let formData = new FormData();
                    formData.append('file', file);
                    formData.append('nomDocumentDemande', file.name);
                    formData.append('idDPSdemande', sendToBO.data.idDPSdemande);
                    formData.append('demandeUpdateCode', sendToBO.data.demandeUpdateCode);

                    await AxiosUpload.post('/publicRoutes/uploadDpsDemandeDocAttached', formData);
                }
            }

            await Axios.post('/publicRoutes/cloreDemandeDPS',{
                idDPSdemande: sendToBO.data.idDPSdemande,
                demandeUpdateCode: sendToBO.data.demandeUpdateCode,
            });

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        sendToDB();
    },[])
    
    if(isLoading)
    {
        return(<LoaderInfiniteLoop />);
    }else{
        return (<>
            <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-success"}>
                <center>
                    <h5 className='text-success mb-2'><b>MERCI</b></h5>
                    <p>Votre demande est bien prise en compte, nous reviendrons vers vous rapidement.</p>
                    <IconButton
                        icon={'recycle'}
                        onClick={resetForm}
                        className='mt-3'
                        size='sm'
                        variant='outline-primary'
                    >Faire une autre demande</IconButton>
                </center>
            </div>
        </>);
    }
    
};


DemandeDPSStep6.propTypes = {};

export default DemandeDPSStep6;